import { processCourse } from '@api/processors/course';

const processTestSeriesEntity = (feedBlock) => ({
  label: feedBlock.label || feedBlock.extraBlockInfo.label || '',
  type: feedBlock.type,
  courses: feedBlock.data.map((course) =>
    processCourse({ ...course, ...(course.programme || {}) })
  ),
  extraBlockinfo: {
    count: feedBlock.data.length || 0,
    ...(feedBlock.extraBlockInfo || {})
  }
});

export default processTestSeriesEntity;
